import { useSyncExternalStore } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '~/components/ui/Button';
import { CONSENT_EVENT, getConsent, setConsent, type ConsentValue } from '~/lib/consent';

function subscribe(onChange: () => void) {
  window.addEventListener(CONSENT_EVENT, onChange);
  window.addEventListener('storage', onChange);
  return () => {
    window.removeEventListener(CONSENT_EVENT, onChange);
    window.removeEventListener('storage', onChange);
  };
}

export function CookieBanner() {
  const show = useSyncExternalStore(
    subscribe,
    () => getConsent() === null,
    () => false,
  );

  if (!show) return null;

  const decide = (value: ConsentValue) => setConsent(value);

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      className="fixed inset-x-3 bottom-3 z-[90] sm:inset-x-auto sm:right-5 sm:bottom-5 sm:max-w-[380px]">
      <div className="rounded-[24px] bg-white p-5 shadow-[0_12px_48px_rgba(0,0,0,0.14)] ring-1 ring-black/6">
        <div className="space-y-2.5">
          <p className="text-body font-semibold text-ink">We use cookies</p>
          <p className="text-[14px] leading-[1.5] text-grey-900">
            We use cookies and similar technologies to analyse traffic and improve nsave. Read our{' '}
            <Link
              to="/privacy-policy"
              className="underline underline-offset-2 transition-colors hover:text-ink">
              privacy policy
            </Link>
            .
          </p>
        </div>
        <div className="mt-5 flex items-center gap-2.5">
          <Button variant="primary" size="md" onClick={() => decide('accepted')}>
            Accept
          </Button>
          <Button variant="secondary" size="md" onClick={() => decide('rejected')}>
            Reject
          </Button>
        </div>
      </div>
    </div>
  );
}
